import { Box, Icon, List } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  onClick: () => void
}

const Item = ({ title, onClick }: Props) => {
  return (
    <List.ClickableItem navigateTo={onClick}>
      <List.Title>{title}</List.Title>
      <Box
        padding="s2"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'rel500',
        }}
      >
        <Icon.Medium icon="arrow-right" />
      </Box>
    </List.ClickableItem>
  )
}

export default Item
